module.exports = __webpack_public_path__ + "media/images/amenities_icons/footbal-a6bab334ebe3792f697c50f171d9f37f.svg";